module.exports = __webpack_public_path__ + "img/page-signature.35190c1e.jpg";